import React from 'react';

/**
 * Shared Crew Timesheet action button (PP table + Recent Dashboards).
 */
function CrewTimesheetIconButton({
  onClick,
  className = '',
  iconClassName = '',
  disabled = false,
  variant = 'default',
}) {
  const sizeClasses =
    variant === 'table'
      ? 'box-border h-9 sm:h-10 px-2 sm:px-3 leading-none'
      : 'px-2 sm:px-3 py-2 sm:py-2.5';

  return (
    <button
      type="button"
      title="Crew Timesheet"
      aria-label="Crew Timesheet"
      disabled={disabled}
      onClick={onClick}
      className={`inline-flex items-center justify-center ${sizeClasses} text-white bg-cyan-700 rounded-md hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`${iconClassName || 'block h-4 w-4'} shrink-0`}
        aria-hidden="true"
      >
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <rect x="8" y="2" width="8" height="4" rx="1" />
        <path d="M8 12h3" />
        <path d="M8 16h2" />
        <path d="M15 13l4.5-4.5a1.414 1.414 0 0 1 2 2L17 15l-2.5.5L15 13z" />
      </svg>
    </button>
  );
}

export default CrewTimesheetIconButton;
